<template>
    <div class="mainBody">
        <div class="searchBox">
            <div class="searchGroup">
                <label>日期：</label>
                <el-input v-model="search_Obj.f_start_day" clearable @keyup.enter.native="doSearch"></el-input>
            </div>
            <div class="searchGroup">
                <label>邮箱：</label>
                <el-input v-model="search_Obj.f_email" clearable @keyup.enter.native="doSearch"></el-input>
            </div>
            <div class="searchGroup">
                <label>CarId：</label>
                <el-input v-model="search_Obj.f_car_id" clearable @keyup.enter.native="doSearch"></el-input>
            </div>
            <el-button type="primary" plain @click.native="doSearch">搜索</el-button>
            <Btns :menu_id="menu_id" :menus="main_btns" @on_btnclk="btnClick"></Btns>
        </div>
        <div class="dataBox">
            <el-table :data="tableData" :default-sort="sortData" @sort-change="sortChange" @selection-change="selectChanges" v-loading="loading" border stripe>
                <el-table-column prop="start_day" label="日期" sortable="custom">
                    <template slot-scope="scope">
                        <span>{{scope.row.start_day}} 至 {{scope.row.end_day}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="email" label="邮箱" sortable="custom"></el-table-column>
                <el-table-column prop="car_id" label="CarId" sortable="custom"></el-table-column>
                <el-table-column prop="drive_count" label="行驶次数" sortable="custom" width="120"></el-table-column>
                <el-table-column prop="mileage" label="行驶里程" sortable="custom" width="120"></el-table-column>
                <el-table-column prop="charge_count" label="充电次数" sortable="custom" width="120"></el-table-column>
                <el-table-column prop="add_time" label="记录时间" sortable="custom"></el-table-column>
                <el-table-column label="操作" width="120" align="center">
                    <template slot-scope="scope">
                        <LabBtns :menu_id="menu_id" :row="scope.row" :index="scope.$index" :menus="lab_btns" @on_btnclk="labelClick"></LabBtns>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pageBox">
            <el-pagination background layout="total, prev, pager, next, jumper" :current-page="current" :total="total" @current-change="pageChange"></el-pagination>
        </div>
        <Edit
            width="600px"
            :id="model_id"
            :title="edit_title"
            :isshow="editshow"
            @on-close="closeEditDialog"
            @on-save-ok="saveOk">
        </Edit>
        <Info
            width="600px"
            :id="model_id"
            title="查看月报告"
            :isshow="infoshow"
            @on-close="closeInfoDialog">
        </Info>
    </div>
</template>

<script>
import Btns from "@/components/common/btns"
import LabBtns from "@/components/common/labbtns"
import Edit from "./edit"
import Info from "./info"
import listutil from "@/libs/listutil"

export default {
    name: 'carWeekList',
    mixins: [listutil],
    components: {Edit, Info, Btns, LabBtns},
    data() {
        return {
            m_name: '月报告',
            menu_id: 5200,
            list_url: "/api/admin/carweek/list",
            search_Obj: {
                f_email: '',
                f_car_id: '',
                f_start_day: ''
            },
            del_Obj:{
                url:'/api/admin/carweek/del',
                data:{
                    ids:''
                }
            },
            enu_name: [],
        };
    },
    methods: {}
};
</script>